export type NoteValidationMode = "typing" | "submit";

export interface NoteValidationResult {
  noteTextError: boolean;
  noteErrorText: string;
  disableNoteSave: boolean;
}

const useNoteValidation = () => {
  const getNoteValidation = (
    noteText: string,
    mode: NoteValidationMode,
    deleteNote?: boolean,
  ): NoteValidationResult => {
    if (noteText.length >= 5 && noteText.length <= 500) {
      return {
        noteTextError: false,
        noteErrorText: "",
        disableNoteSave: false,
      };
    }

    if (noteText.length > 500) {
      return {
        noteTextError: true,
        noteErrorText: "Note cannot exceed 500 characters.",
        disableNoteSave: true,
      };
    }

    if (noteText.length === 0 && mode === "typing" && deleteNote) {
      return {
        noteTextError: true,
        noteErrorText: "To delete this note, click 'Delete Note' below.",
        disableNoteSave: false,
      };
    }

    if (noteText.length < 5 && mode === "submit") {
      return {
        noteTextError: true,
        noteErrorText: "Note must be at least 5 characters.",
        disableNoteSave: true,
      };
    }

    return {
      noteTextError: false,
      noteErrorText: "",
      disableNoteSave: true,
    };
  };

  return { getNoteValidation };
};

export { useNoteValidation };
